import React from 'react'

const ListCompany = () => {
  return (
    <div>ListCompany</div>
  )
}

export default ListCompany